"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresGet200ResponseToJSON = exports.ApiStoresGet200ResponseFromJSONTyped = exports.ApiStoresGet200ResponseFromJSON = exports.instanceOfApiStoresGet200Response = void 0;
var runtime_1 = require("../runtime");
var StoresInner_1 = require("./StoresInner");
/**
 * Check if a given object implements the ApiStoresGet200Response interface.
 */
function instanceOfApiStoresGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresGet200Response = instanceOfApiStoresGet200Response;
function ApiStoresGet200ResponseFromJSON(json) {
    return ApiStoresGet200ResponseFromJSONTyped(json, false);
}
exports.ApiStoresGet200ResponseFromJSON = ApiStoresGet200ResponseFromJSON;
function ApiStoresGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'stores': !(0, runtime_1.exists)(json, 'stores') ? undefined : (json['stores'] === null ? null : json['stores'].map(StoresInner_1.StoresInnerFromJSON)),
        'userInvitationToken': !(0, runtime_1.exists)(json, 'user_invitation_token') ? undefined : json['user_invitation_token'],
        'totalCount': !(0, runtime_1.exists)(json, 'total_count') ? undefined : json['total_count'],
        'page': !(0, runtime_1.exists)(json, 'page') ? undefined : json['page'],
        'perPage': !(0, runtime_1.exists)(json, 'per_page') ? undefined : json['per_page'],
        'totalPages': !(0, runtime_1.exists)(json, 'total_pages') ? undefined : json['total_pages'],
    };
}
exports.ApiStoresGet200ResponseFromJSONTyped = ApiStoresGet200ResponseFromJSONTyped;
function ApiStoresGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'stores': value.stores === undefined ? undefined : (value.stores === null ? null : value.stores.map(StoresInner_1.StoresInnerToJSON)),
        'user_invitation_token': value.userInvitationToken,
        'total_count': value.totalCount,
        'page': value.page,
        'per_page': value.perPage,
        'total_pages': value.totalPages,
    };
}
exports.ApiStoresGet200ResponseToJSON = ApiStoresGet200ResponseToJSON;
